export enum SensorProduct {
  None = 'none',
  VegetronixVH400 = 'Vegetronix VH400',
  VegetronixTHERM200 = 'Vegetronix THERM200',
  Dwyer628 = 'Dwyer 628',
  AgriDrain800770 = 'Agri Drain 800770',
  DEMPaddleWheel = 'DEM PaddleWheel',
  Badgermeter220BR = 'Badgermeter 220BR',
  IrrometerWM200SS = 'Irrometer WM200SS',
  SwitchNormallyOpen = 'Switch (normally open)',
  SwitchNormallyClosed = 'Switch (normally closed)',
  BadgermeterSDI = 'Badgermeter SDI',
  WindDirection = 'Wind Direction',
  WindSpeed = 'Wind Speed',
  Pressure = 'Pressure',
  Rainfall = 'Rainfall',
  SolarRadiation = 'Solar Radiation',
  Humidity = 'Humidity',
  Temperature = 'Temperature Sensor',
  CountButtonCB100 = 'Count Button',
  ServiceButtonSB100 = 'Service Button',
  TiltSensorTS100 = 'Tilt Sensor',
  Battery = 'Battery',
  AquaTroll500DissolvedOxygenSensor = 'AquaTROLL Dissolved Oxygen',
  AquaTroll500TurbiditySensor = 'AquaTROLL Turbidity',
  AquaTroll500TotalDissolvedSolidsSensor = 'AquaTROLL Total Dissolved Solids',
  AquaTroll500NitrateSensor = 'AquaTROLL Nitrate',
  AquaTroll500SpecificConductivitySensor = 'AquaTROLL Specific Conductivity',
  AquaTroll500SalinitySensor = 'AquaTROLL Salinity',
  AquaTroll500TemperatureSensor = 'AquaTROLL Temperature',
  OpticalRainSensorSAB = 'Optical Rain Sensor SAB',
  OpticalRainSensorPower = 'Optical Rain Sensor Power',
}

export const UnitCategoryMap = {
  1: 'Volume',
  2: 'VolumeRate',
  3: 'Temperature',
  4: 'VolumetricWaterContent',
  5: 'VolumePulse',
  6: 'DepthHeightDistance',
  7: 'Pressure',
  8: 'ElectricPotentialDifference',
  9: 'SwitchContact',
  10: 'TotalVolume',
  11: 'PressureGauge',
  12: 'WindDirection',
  13: 'WindSpeed',
  14: 'Rainfall',
  15: 'SolarRadiation',
  16: 'Humidity',
  17: 'WindDistribution',
  18: 'RainfallRate',
  21: 'DissolvedOxygen',
  22: 'Turbidity',
  23: 'DissolvedSolids',
  24: 'Nitrates',
  25: 'SpecificConductivity',
  26: 'Salinity',
  27: 'WaterTemperature',
  28: 'SoilTemperature',
}

export enum UnitCategoryId {
  Volume = 1,
  VolumeRate = 2,
  Temperature = 3,
  VolumetricWaterContent = 4,
  VolumePulse = 5,
  DepthHeightDistance = 6,
  Pressure = 7,
  ElectricPotentialDifference = 8,
  SwitchContact = 9,
  TotalVolume = 10,
  PressureGauge = 11,
  WindDirection = 12,
  WindSpeed = 13,
  Rainfall = 14,
  SolarRadiation = 15,
  Humidity = 16,
  WindDistribution = 17,
  RainfallRate = 18,
  DissolvedOxygen = 21,
  Turbidity = 22,
  DissolvedSolids = 23,
  Nitrates = 24,
  SpecificConductivity = 25,
  Salinity = 26,
  WaterTemperature = 27,
  SoilTemperature = 28,
}

export enum SensorPort {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  T0 = 'T0',
  Unknown = 'Unknown',
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

export enum UserRole {
  Admin = 'Admin',
  Customer = 'Customer',
}

export enum BaseStationType {
  Sigfox = 1,
}

export enum ProductType {
  RIC1010 = 'RIC1010',
  RIC1020 = 'RIC1020',
  RIC1030 = 'RIC1030',
}

export enum NotificationType {
  Sms = 'Sms',
  Email = 'Email',
}

export enum EventType {
  Low = 'Low',
  High = 'High',
}

export enum SensorType {
  None = 'None',
  AgriDrain800770 = 'AgriDrain800770',
  AquaTroll500DissolvedOxygenSensor = 'AquaTroll500DissolvedOxygenSensor',
  AquaTroll500NitrateSensor = 'AquaTroll500NitrateSensor',
  AquaTroll500SalinitySensor = 'AquaTroll500SalinitySensor',
  AquaTroll500SpecificConductivitySensor = 'AquaTroll500SpecificConductivitySensor',
  AquaTroll500TemperatureSensor = 'AquaTroll500TemperatureSensor',
  AquaTroll500TotalDissolvedSolidsSensor = 'AquaTroll500TotalDissolvedSolidsSensor',
  AquaTroll500TurbiditySensor = 'AquaTroll500TurbiditySensor',
  Badgermeter220BR = 'Badgermeter220BR',
  BadgermeterSDI = 'BadgermeterSDI',
  Battery = 'Battery',
  DEMPaddleWheel = 'DEMPaddleWheel',
  Dwyer628 = 'Dwyer628',
  Humidity = 'Humidity',
  IrrometerWM200SS = 'IrrometerWM200SS',
  Pressure = 'Pressure',
  Rainfall = 'Rainfall',
  OpticalRainSensorSAB = 'OpticalRainSensorSAB',
  OpticalRainSensorPower = 'OpticalRainSensorPower',
  SolarRadiation = 'SolarRadiation',
  SwitchNormallyClosed = 'SwitchNormallyClosed ',
  SwitchNormallyOpen = 'SwitchNormallyOpen',
  Temperature = 'Temperature',
  Unknown = 'Unknown',
  VegetronixVH400 = 'VegetronixVH400',
  VegetronixTHERM200 = 'VegetronixTHERM200',
  WindDirection = 'WindDirection',
  WindSpeed = 'WindSpeed',
  CountButtonCB100 = 'CountButtonCB100',
  ServiceButtonSB100 = 'ServiceButtonSB100',
  TiltSensorTS100 = 'TiltSensorTS100',
}

export enum UnitCategory {
  Unknown = 'Unknown',
  Volume = 'Volume',
  VolumeRate = 'VolumeRate',
  Temperature = 'Temperature',
  VolumetricWaterContent = 'VolumetricWaterContent',
  VolumePulse = 'VolumePulse',
  DepthHeightDistance = 'DepthHeightDistance',
  Pressure = 'Pressure',
  ElectricPotentialDifference = 'ElectricPotentialDifference',
  SwitchContact = 'SwitchContact',
  TotalVolume = 'TotalVolume',
  PressureGauge = 'PressureGauge',
  WindDirection = 'WindDirection',
  WindSpeed = 'WindSpeed',
  Rainfall = 'Rainfall',
  SolarRadiation = 'SolarRadiation',
  Humidity = 'Humidity',
  WindDistribution = 'WindDistribution',
  RainfallRate = 'RainfallRate',
}

// export enum UnitCategory {
//   Volume = 'Vol',
//   VolumeRate = 'VRate',
//   Temperature = 'Temp',
//   VolumetricWaterContent = 'VWC',
//   VolumePulse = 'VPulse',
//   DepthHeightDistance = 'Depth',
//   Pressure = 'Pres',
//   ElectricPotentialDifference = 'EPD',
//   SwitchContact = 'Switch',
//   TotalVolume = 'TVol',
//   PressureGauge = 'PresG',
//   WindDirection = 'WDir',
//   WindSpeed = 'WSpd',
//   Rainfall = 'Rain',
//   SolarRadiation = 'SolRad',
//   Humidity = 'HMD',
//   WindDistribution = 'WDst',
//   RainfallRate = 'RRate',
// }

export enum BaseUnits {
  Volume = 'cubic meters',
  VolumeRate = 'cubic meters / seconds',
  Temperature = 'celsius',
  VolumetricWaterContent = 'percent',
  VolumePulse = 'cubic meters',
  DepthHeightDistance = 'meter',
  Pressure = 'pascals',
  ElectricPotentialDifference = 'volts',
  SwitchContact = 'percent',
  TotalVolume = 'cubic meters',
  PressureGauge = 'pascals',
  WindDirection = 'pounds / square inch',
  WindSpeed = 'meters / second',
  Rainfall = 'meters',
  SolarRadiation = 'watts / square meter',
  Humidity = 'percent',
  WindDistribution = 'percent',
  RainfallRate = 'millimeters / minute',
  DissolvedOxygen = 'milligrams / liter',
  Turbidity = 'NTU',
  TotalDissolvedSolids = 'parts per million',
  Nitrates = 'milligrams / liter',
  SpecificConductivity = 'microsimoles / centimeter',
  Salinity = 'practical salinity unit',
  Count = 'count',

  // special cases
  Battery = 'voltage',
  Message = 'message',

  Unknown = 'unknown',
}

export enum SoilType {
  Sand = 'Sand',
  LoamySand = 'LoamySand',
  SandyLoam = 'SandyLoam',
  Loam = 'Loam',
  SiltLoam = 'SiltLoam',
  Silt = 'Silt',
  SandyClayLoam = 'SandyClayLoam',
  SiltyClayLoam = 'SiltyClayLoam',
  SiltyClay = 'SiltyClay',
  Clay = 'Clay',
}

export enum SigfoxMessageType {
  TestMessage = 0x04,
  SeqNumTimestamp = 0x05,
  ScheduledReading = 0x06,
  DeviceConfig1 = 0x07,
  DeviceConfig2 = 0x08,
  DeviceConfig3 = 0x09,
  DeviceConfig4 = 0x0a,
  DeviceConfig5 = 0x0b,
  SensorConfig1 = 0x0c,
}

export enum CoordinateType {
  NotSet = 'NotSet',
  LatLong = 'LatLong',
  UTM = 'UTM',
  MGRS = 'MGRS',
}

export enum DeviceMode {
  Standard = 'Standard',
  WeatherStation = 'Weather Station',
  WaterQuality = 'Water Quality',
  DirtTracker = 'Dirt Tracker',
  Unknown = 'Unknown',
}

export declare class TDevice {
  DEVICE_ID: number
  SERIAL_NUMBER: number
  HW_VERSION: number
  WISOL_ID: string
  WISOL_PAC: string
  SIGFOX_REG: number
  DEV_PRODUCT_ID: number
  DATE_CODE: string
  LOCATION_ID: number
  MSG_SNTS_ID: number
  RUN_ID: number
  LIC_COUNT: number
  DEV_KEY: string
  DATE_UPDATE: Date
  DATE_CREATE: Date
}

export declare class TDeviceCfg {
  DEVCFG_ID: number
  DEVICE_ID: number
  DEVICE_NAME: string
  DEV_CFG_FLAGS: number
  SNTS_FREQ: number
  SCHD_FREQ: number
  FW_VERSION: number
  COORD_TYPE: number
  COORD_NS_VALUE: number
  COORD_EW_VALUE: number
  COORD_Z_VALUE: number
  COORD_GRIDZONE: string
  SITE_NAME: string
  SITE_CODE: string
  DEV_PIN: string
  DEV_APP: number
  DATE_EFFECT: Date
  DATE_CREATE: Date
  DATE_UPDATE: Date
}

export declare class TMessageSigfoxOut {
  MSG_RAW_ID: number
  SIGFOX_ID: string
  SIGFOX_SNUM: string
  SIGFOX_TIME: number
  SIGFOX_STAT: string
  MSG_CONTENT: string
  ERROR_CODE: number
  DATE_INRECV: Date
  DATE_CREATE: Date
  DATE_UPDATE: Date
}

export declare class TSensorSetting {
  SNSSET_ID: number
  DEVICE_ID: number
  SNS_NUMBER: number
  AREA_VALUE: number
  AREA_ENABLE: number
  VIEW_FLAGS: number
  WARN_FLAGS: number
  OTHER_FLAGS: number
  WARN_CHANGE: number
  WARN_HIGH: number
  WARN_LOW: number
  DELTA_VALUE: number
  MSG_ID_TOTAL: number
  CALC_TOTAL: number
  CALC_RATE: number
  CALC_VOLUME: number
  DATE_CREATE: Date
  DATE_UPDATE: Date
}

export enum SigFoxMessageType {
  TestMessage = 0x04,
  SNTS = 0x05, // SNTS = sequence number and timestamp
  SCHD = 0x06, // SCHD = scheduled reading
  DeviceConfig1 = 0x07,
  DeviceConfig2 = 0x08,
  DeviceConfig3 = 0x09,
  DeviceConfig4 = 0x0a,
  DeviceConfig5 = 0x0b,
  SensorConfig1 = 0x0c,
  Unknown = 0xff,
}

export type Devices = Record<string, DeviceInfo>
export interface DeviceInfo {
  coordinateEWValue: number
  coordinateGridzone: string
  coordinateNSValue: number
  coordinateType: number
  coordinateZValue: number
  dateCode: string
  description: string
  deviceApp: number
  deviceConfigFlags: number
  deviceConfigId: number
  deviceId: number
  deviceName: string
  deviceProductId: number
  firmwareVersion: number
  hardwareNumber: number
  locationId: number
  messageSequenceNumberTimestampId: number
  scheduledMessagesFrequency: number
  sequenceNumberTimestampFrequency: number
  serialNumber: number
  sigfoxId: string
  sigfoxReg: number
  siteCode: number | string | null
  siteName: string
  wisolId: string
  wisolPac: string
  // Optional: timestamp of last device reading (Unix timestamp in seconds, ISO string, or Date)
  // Used to determine device online/offline status
  lastReadingTimestamp?: number | string | Date
  // Optional: priority device fields
  isPriority?: boolean
  priorityOrder?: number
  // Optional: admin-only — name of the account/location this device belongs to.
  // Populated by /devices when the caller has the ADMIN role; absent otherwise.
  accountName?: string
}

export const LINE_COLORS: Record<string, string> = {
  A1: '#FFA500',
  A2: '#FF0000',
  B1: '#0000FF',
  B2: '#00FF00',
  C1: '#FF00FF',
  C2: '#00FFFF',
  C3: '#FFFF00',
}

export const SensorProductIdLookup: Record<number, SensorType> = {
  1: SensorType.None,
  2: SensorType.VegetronixVH400,
  3: SensorType.Dwyer628,
  4: SensorType.AgriDrain800770,
  5: SensorType.DEMPaddleWheel,
  6: SensorType.Badgermeter220BR,
  7: SensorType.IrrometerWM200SS,
  8: SensorType.SwitchNormallyOpen,
  9: SensorType.SwitchNormallyClosed,
  10: SensorType.BadgermeterSDI,
  11: SensorType.WindDirection,
  12: SensorType.WindSpeed,
  13: SensorType.Pressure,
  14: SensorType.Rainfall,
  15: SensorType.SolarRadiation,
  16: SensorType.Humidity,
  17: SensorType.Temperature,
  18: SensorType.CountButtonCB100,
  19: SensorType.ServiceButtonSB100,
  20: SensorType.TiltSensorTS100,
  21: SensorType.AquaTroll500DissolvedOxygenSensor,
  22: SensorType.AquaTroll500TurbiditySensor,
  23: SensorType.AquaTroll500TotalDissolvedSolidsSensor,
  24: SensorType.AquaTroll500NitrateSensor,
  25: SensorType.AquaTroll500SpecificConductivitySensor,
  26: SensorType.AquaTroll500SalinitySensor,
  27: SensorType.AquaTroll500TemperatureSensor,
  28: SensorType.VegetronixTHERM200,
  29: SensorType.OpticalRainSensorSAB,
  30: SensorType.OpticalRainSensorPower,
}

// 3: 'Dwyer 628',
// 4: 'Agri Drain 800770',
// 5: 'DEM PaddleWheel',
// 6: 'Badgermeter 220BR',
// 7: 'Irrometer WM200SS',
// 8: 'Switch (normally open)',
// 9: 'Switch (normally closed)',
// 10: 'Badgermeter SDI',
// 11: 'Wind Direction',
// 12: 'Wind Speed',
// 13: 'Pressure',
// 14: 'Rainfall',
// 15: 'Solar Radiation',
// 16: 'Humidity',
// 17: 'Temperature',
// 18: 'Count Button',
// 19: 'Service Button',
// 20: 'Tilt Sensor',
// 21: 'AquaTROLL Dissolved Oxygen',
// 22: 'AquaTROLL Turbidity',
// 23: 'AquaTROLL Total Dissolved Solids',
// 24: 'AquaTROLL Nitrate',
// 25: 'AquaTROLL Specific Conductivity',
// 26: 'AquaTROLL Salinity',
// 27: 'AquaTROLL Temperature',
// 28: 'Vegetronix THERM200',
